import React from 'react'
import { TableVirtualized } from '../../root/components/common/table-virtualized/table'
import { useSelector, useDispatch } from 'react-redux'
import { useQuery } from 'react-query'
import { fetchDeviceMoveHistory } from '../api/device-api'
import { makeStyles } from '@material-ui/core/styles'
import { enqueueSnackbar } from '../../root/actions'
import { compareDateStringsDesc } from '../utils'
import { getFormattedDate } from 'web/src/utils'
function MoveHistoryTable({ device }) {
    const { locale } = useSelector(state => state.main)
    const styles = useStyles()
    const dispatch = useDispatch()
    const { data, isLoading } = useQuery(
        ['deviceMoveHistory', device.id],
        () => fetchDeviceMoveHistory(device.id),
        {
            refetchInterval: false,
            refetchOnWindowFocus: false,
            onError: () =>
                dispatch(
                    enqueueSnackbar({
                        message: locale.sagasMsgs.getDeviceHistoryEx,
                        options: {
                            variant: 'error'
                        }
                    })
                )
        }
    )
    const EventLabel = ({ children }) => {
        const classes = useStyles()
        return <div className={classes.eventLabel}>{children}</div>
    }
    const columns = [
        {
            key: 'moved_by_name',
            label: 'Moved By',
            sortable: true,
            dataType: 'string',
            width: 1.5,
            render: ({ rowData }) => <div>{rowData.moved_by_name}</div>
        },
        {
            key: 'event',
            label: 'Event',
            sortable: false,
            dataType: 'string',
            width: 1,
            render: ({ rowData }) => (
                <EventLabel>{locale.devices.move}</EventLabel>
            )
        },
        {
            key: 'location_from_name',
            label: 'Location From',
            sortable: true,
            dataType: 'string',
            width: 1.5,
            render: ({ rowData }) => <div>{rowData.location_from_name}</div>
        },
        {
            key: 'location_to_name',
            label: 'Location To',
            sortable: true,
            dataType: 'string',
            width: 1.5,
            render: ({ rowData }) => <div>{rowData.location_to_name}</div>
        },
        {
            key: 'created_at',
            label: 'Date',
            sortable: true,
            dataType: 'string',
            width: 1.5,
            render: ({ rowData }) => (
                <div>{getFormattedDate(rowData.created_at)}</div>
            )
        }
    ]

    return (
        <React.Fragment>
            <div className={styles.resultsTable}>
                {data?.length || isLoading ? (
                    <TableVirtualized
                        data={data?.sort(
                            ({ created_at: date1 }, { created_at: date2 }) =>
                                compareDateStringsDesc(date1, date2)
                        )}
                        isLoading={isLoading}
                        columns={columns}
                    />
                ) : (
                    <div className={styles.noResults}>
                        {locale.devices.noDeviceMoveHistoryMsg}
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}
const useStyles = makeStyles(theme => ({
    noResults: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    resultsTable: {
        height: 500,
        width: '100%',
        padding: '0 32px 20px 32px'
    },
    eventLabel: {
        backgroundColor: theme.palette.grey[200],
        borderRadius: '16px',
        padding: '4px 8px',
        fontSize: '0.9rem'
    }
}))

export { MoveHistoryTable }
